import 'babel-polyfill'
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { HashRouter as Router } from 'react-router-dom'
import * as serviceWorker from './serviceWorker';
import './utils/rem'
import './styles/normalize.css'
import VConsole from 'vconsole/dist/vconsole.min.js'
import './utils/bus'
import './base/createLogger'
import './collectionData/sensors'
import { setMitoUserId } from './utils/mitoSDK';

import './utils/initLogin'
import { initHLLReviewAppUserStorage } from './pages/teacher-data-board-v2/util';
import { initNativeListener } from '@hltn/hll-comment-native-sdk'

console.log('--ops构建调试-live-app-h5--')

if (process.env.REACT_APP_MODE === 'development' || process.env.REACT_APP_MODE === 'test' || process.env.REACT_APP_MODE === 'preprod') {
    // eslint-disable-next-line
    let vconsole = new VConsole()
    console.log('页面url:', window.location.href)
} else if (window.localStorage.getItem('this_is_test') === '61draw' || window.location.href.indexOf("this_is_test=61draw") !== -1) {
    Log.setlevel('all');
    Log.debug("打开debug调试");
    new VConsole()
}
// 此处监控初始化已经前置，通过CDN方式引入
// const instance = init({
//     service: "live-app-h5",
//     debug: true,
//     silentConsole: true,
//     maxBreadcrumbs: 20,
//     bizInfo: {
//         pageTitle: document.title,
//         subject: HltnSubjectType.other,
//         bizType: HltnBizType.workbranch,
//     },
//     // dsn: "http://reporter-fat.61info.cn/o/v1/upload"
//     dsn: `${FE_MITO_DSN}/o/v1/upload`,
//     webPerformance: true,
// });
// window._MITO_ = instance;
class MainApp extends React.Component {
    render() {
        return (
            <Router>
                <App />
            </Router>
        )
    }
}

ReactDOM.render(React.createElement('div', {
    children: React.createElement(MainApp),
    // MitoInstance: instance
}), document.getElementById('root'))

serviceWorker.unregister();

initNativeListener()

initHLLReviewAppUserStorage()

// 已在initLogin模块中 完成用户数据获取
setMitoUserId(localStorage.getItem('userId'))
